import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-flower',
  templateUrl: './icon-flower.component.svg',
})
export class SvgFlowerComponent {}
